import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './button';

/**
 * Pagination d'une liste rendue côté client.
 *
 * Les listes d'examens affichaient leurs 90 lignes d'un bloc. Ce composant
 * découpe l'affichage sans changer la source : c'est l'écran qui garde ses
 * données, il ne reçoit ici que la page courante.
 *
 * Ne s'affiche pas quand tout tient sur une page — une barre de pagination
 * pour une seule page est du bruit.
 */
const Pagination = ({
  page,
  nombrePages,
  total,
  parPage,
  onChangerPage,
  libelleElement = 'élément'
}) => {
  if (nombrePages <= 1) {
    return (
      <p className="px-1 text-[11px] text-gray-500">
        {total} {libelleElement}{total > 1 ? 's' : ''}
      </p>
    );
  }

  const premier = (page - 1) * parPage + 1;
  const dernier = Math.min(page * parPage, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1">
      <p className="text-[11px] text-gray-500">
        {premier}–{dernier} sur {total} {libelleElement}{total > 1 ? 's' : ''}
      </p>

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onChangerPage(page - 1)}
          className="gap-1"
        >
          <ChevronLeft size={14} />
          Précédent
        </Button>

        <span className="text-[11px] font-semibold tabular-nums text-gray-600">
          {page} / {nombrePages}
        </span>

        <Button
          variant="outline"
          size="sm"
          disabled={page >= nombrePages}
          onClick={() => onChangerPage(page + 1)}
          className="gap-1"
        >
          Suivant
          <ChevronRight size={14} />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
